exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".markerTable[data-v-e3086c6a]  .el-checkbox{margin:0!important}.markerTable .el-table td[data-v-e3086c6a],.markerTable[data-v-e3086c6a]  .el-table th.is-leaf{border:none!important}", ""]);

// exports
